
// takes any type of entry and the site config.
export const getTeaserImageUrlByEntry = (entry: any, config: any, width:number = 413, height:number = 200, useFallback:boolean = true) => {
  const fallback = (useFallback) ? config.fallbackImageForCards.url : ''
  let teaserImage = fallback

  // if Article, use the articleSeo.teaserImage
  if(entry?.articleSeo?.teaserImage?.url) {
    teaserImage = `${entry?.articleSeo?.teaserImage?.url}`
  }
  // if Case Study, use the caseStudySeo.teaserImage
  else if(entry?.caseStudySeo?.teaserImage?.url) {
    teaserImage = `${entry?.caseStudySeo?.teaserImage?.url}`
  }
  // if video/docs/externalresources, use the seo.teaserImage
  else if(entry?.seo?.teaserImage?.url) {
    teaserImage = `${entry?.seo?.teaserImage?.url}`
  }

  /* if the image is a BMP, we want to use the fallback */
  if(teaserImage.includes('.bmp')) { teaserImage = fallback }

  /* add the Contentful customization */
  const teaserImageThroughAPI = `${teaserImage}?w=${width}&h=${height}&fit=fill&fm=webp`

  return teaserImageThroughAPI
}

// if an image URL is provided, it will return the image URL with the specified parameters
export const qualifyImageUrl = (imageUrl: string, width: number = 413, height: number = 200) => {
  if (!imageUrl) return '' // Return empty string if no image URL is provided

  // If the image is a BMP, return nothing.
  if (imageUrl.includes('.bmp')) { return '' }

  // Otherwise, return the image URL with the specified parameters
  return `${imageUrl}?w=${width}&h=${height}&fit=fill&fm=webp`;
}